import {BaseModel} from "../base.model";

export interface RelationshipTree extends BaseModel {
    
}

export const defaultRelationshipTree:  Readonly<RelationshipTree> = {};